import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import PhoneRegularDiagonalIn from './phone-regular-diagonal-in-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <PhoneRegularDiagonalIn {...validProps} />;
}
SvgComponent.iconName = 'phoneRegularDiagonalIn';

export const PhoneRegularDiagonalInIcon = svgIconWrapper(SvgComponent);
